import axios from 'axios';
import Globals from '../Globals';
import LoggingService from './LoggingService';
import { getLogModel } from '../Functions';

class UserService {
    base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.USER.BASE_PATH;

    getUser = async (token, register) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        return await axios
            .post(
                this.base_url +
                    (register
                        ? Globals.BFF_PATH.USER.GET_USER_REGISTER
                        : Globals.BFF_PATH.USER.GET_USER),
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    register = async (token, body) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(body),
        };
        return axios
            .post(this.base_url + Globals.BFF_PATH.USER.REGISTER, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getPreferences = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        return await axios
            .post(this.base_url + '/get-preferences', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getDataspreferenceAndTransport = async (token, object) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url + '/get-preferences-id-transport-id',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    savePreferences = async (token, object) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(this.base_url + '/post-preferences', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    SaveDataUser = async (token, object) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(this.base_url + '/update-data-user', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    UpdatePassword = async (token, object) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token.AccessToken}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: JSON.stringify(token), //`${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };

        //return await axios.post(this.base_url + "/update-password-user", data, config)
        return await axios
            .post(this.base_url + '/update-password', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
                // return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    ResetPassword = async (token, object) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(this.base_url + '/post-password', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getBuyerType = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        return await axios
            .post(this.base_url + '/get-buyer-type', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getDealerCode = async (token, idCanal) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(idCanal),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.DEALER.GET_DEALER_CODE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getDefaultDealer = async (token, idCanal) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(idCanal),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.DEALER.GET_DEFAULT_DEALER,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getGlobalVariable = async (token, variableName) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(variableName),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.GLOBAL_VARIABLES.GET_GLOBAL_VARIABLE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };
}

export default UserService;
